import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useNavigate } from 'react-router-dom'
import { useHistory } from 'shared/hooks/useHistory'
import { useUserContext } from 'shared/hooks/useUserContext'

import styles from './OnboardingApp.module.scss'

const OnboardingApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.ONBOARDING}
        scope='onboarding'
        envKey={apps[AppId.ONBOARDING].runtimeEnvKey}
        entryPath='./OnboardingApp'
        url={process.env.REACT_APP_ONBOARDING_APP_DEV_PATH}
        // appName='Onboarding'
        appName={apps[AppId.ONBOARDING].name}
        className={styles.onboardingAppWrapper}
        appProps={{
          user,
          history,
          appPath: apps[AppId.ONBOARDING].path,
          // appPath: 'onboarding',
          initialPath: location.pathname,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  () => true
)

export { OnboardingApp }
